<template>
  <div class="customer-info">
    <el-tabs v-model="currentTab"  @tab-click='currentTabClick'>
      <el-tab-pane label="公司基础信息" name="baseInfo">
        <company-tab ></company-tab>
      </el-tab-pane>
      <el-tab-pane label="联系人" name="contact">
        <el-row type="flex" justify="space-between">
          <el-col :span="6">
            <h3 class="title">全部联系人</h3>
          </el-col>
          <el-col :span="6" class="text-right">
            <el-button type="primary" @click="handleContactsDialogOpen()">新增联系人</el-button>
          </el-col>
        </el-row>
        <el-form :inline="true" style="margin-top: 20px">
          <el-form-item label="联系人">
            <el-input v-model="contactSearch.Name" placeholder="请输入联系人" style="width: 260px"></el-input>
          </el-form-item>
          <el-form-item label="办事处">
            <el-cascader clearable v-model="contactSearch.Place" style="width: 260px" :options="Provinces" @active-item-change="handleItemChange" :props="{value: 'Id', label: 'Name', children: 'children'}" placeholder="请选择办事处（省/市/区）"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 120px; background: #20a0ff;" :loading="IsLoading" @click="getCustomers">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="IsLoading" element-loading-text="加载中" :data="Customers" class="table-shin-expand">
          <el-table-column type="expand">
            <template scope="props">
              <el-form class="inner-form" :inline="true" label-width="120px" label-suffix="：">
                <el-form-item label="生日" prop="Birthdate">{{props.row.Birthdate | date('YYYY-MM-DD')}}</el-form-item>
                <el-form-item label="手机号" prop="Mobile">{{props.row.Mobile}}</el-form-item>
                <el-form-item label="QQ" prop="QQ">{{props.row.QQ}}</el-form-item>
                <el-form-item label="微信" prop="Weixin">{{props.row.Weixin}}</el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="Name"></el-table-column>
          <el-table-column label="职位" prop="JobTitle"></el-table-column>
          <el-table-column label="办事处" width="300px" prop="StreetAddress"></el-table-column>
          <el-table-column label="操作" width="220px">
            <template scope="props">
              <el-button type="text" @click="handleContactsDialogOpen(props.row)">编辑</el-button>
              <el-button v-if="props.row.Accounts.length === 0" type="text" @click="handleCreatePermissionsDialogOpen(props.row)">分配账户及权限</el-button>
              <el-button type="text" class="danger" @click="handleRemoveContacts(props.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            class="text-right"
            layout="total, prev, pager, next"
            @current-change="getCustomers"
            :total="contactTotal">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="账户及权限" name="permissions">
        <el-row type="flex" justify="space-between">
          <el-col :span="6">
            <h3 class="title">账户及权限</h3>
          </el-col>
        </el-row>
        <el-form :inline="true" style="margin-top: 20px">
          <el-form-item label="联系人">
            <el-input placeholder="请输入联系人" v-model="permissionSearch.Name" style="width: 260px"></el-input>
          </el-form-item>
          <el-form-item label="分部">
            <el-select style="width: 260px"
            placeholder="请选择或输入分部"
            v-model="permissionSearch.PartnerRegionId" 
            filterable
            clearable>
              <el-option 
              v-for="Region in Regions" 
              :key="Region.Code" 
              :label="Region.Name" 
              :value="Region.Code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 120px; background: #20a0ff;" :loading="IsLoading" @click="getPartnerAccounts">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="IsLoading" element-loading-text="加载中" class="table-shin-expand" :data="PartnerAccounts">
          <el-table-column type="expand">
            <template scope="props">
              <el-form class="inner-form" :inline="true" label-width="120px" label-suffix="：">
                <el-form-item label="拥有权限">
                  <span class="permission" v-for="item in props.row.Permission" :key="item">{{ item | Permissions }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="姓名" prop="Name"></el-table-column>
          <el-table-column label="分部" prop="RegionName"></el-table-column>
          <el-table-column label="账户" prop="CustomerName"></el-table-column>
          <!-- <el-table-column label="密码"></el-table-column> -->
          <el-table-column label="操作" width="220px">
            <template scope="props">
              <el-button type="text" @click="handlePermissionsDialogOpen(props.row)">编辑</el-button>
              <el-button type="text" class="danger" @click="handleRemovePermissions(props.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            class="text-right"
            layout="total, prev, pager, next"
            @current-change="permissionPageChange"
            :current-page.sync="permissionPage"
            :total="permissionTotal">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 分部编辑弹窗 -->
    <!-- <spr-dialog name="branchCompany" :show.sync="BranchCompanyDialog.show" title="分部" @confirm="handleBranchCompanyConfirm">
      <el-form label-suffix="：" label-width="100px" style="margin: 0 50px;">
        <el-form-item label="分部名称">
          <el-input style="width: 280px; margin-right: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="分部地址">
          <spr-address></spr-address>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input style="width: 393px"></el-input>
        </el-form-item>
      </el-form>
    </spr-dialog> -->
    <!-- 联系人弹窗 -->
    <contacts-dialog :show.sync="ContactsDialog.show" :form="ContactsDialog.Form" :title="ContactsDialog.Form.Id ? '编辑联系人':'新增联系人'" @confirm="handleContactsConfirm"></contacts-dialog>
    <!-- 权限弹窗 -->
    <permissions-dialog 
      :show.sync="PermissionsDialog.show" 
      :form="PermissionsDialog.Form" 
      :contactName="ContactName"
      :title="PermissionMethod === 'update' ? '编辑账号':'新增账号'"
      :callbackMethod="PermissionMethod"
      @create="handlePermissionsCreate"
      @update="handlePermissionsUpdate"
    ></permissions-dialog>
  </div>
</template>

<script>
import SprDialog from './Dialog'
import SprAddress from '@/components/common/Address'
import ContactsDialog from './ContactsDialog'
import PermissionsDialog from './PermissionsDialog'
import CompanyTab from './CompanyTab'
import o from '@/odata'
export default {
  data() {
    return {
      currentTab: 'baseInfo',
      BranchCompanyDialog: {
        show: false,
      },
      ContactsDialog: {
        show: false,
        Form: {},
      },
      PermissionsDialog: {
        show: false,
        Form: {},
      },
      Provinces: [],
      Customers: [],
      contactSearch: {
        Name: null,
        Place: [],
      },
      contactTotal: 0,
      ContactName: '',
      permissionTotal: 0,
      permissionPage: 1,
      permissionSearch: {
        Name: '',
        PartnerRegionId: '',
      },
      PartnerAccounts: [],
      Regions: [],
      PermissionMethod: '',   // 权限窗口执行的回调方法名 (create,update)
      IsLoading: false,
    }
  },
  methods: {
    handleCompanyConfirm() {
      console.log('company confirm')
    },
    handleBranchCompanyConfirm() {
      console.log('branch company confirm')
    },
    handleBranchCompanyDialogOpen() {
      this.BranchCompanyDialog.show = true
    },
    handleContactsConfirm(Form) {
      let promise
      Form.IsContact = true
      console.log('equals', Form.Birthdate === '')
      Form.Birthdate = Form.Birthdate === '' ? null : Form.Birthdate // 解决日期类型错误
      if (Form.Id) {
        promise = o(`Partner(${Form.Id})`).patch(Form).save()
      } else {
        promise = o('Partner').post(Form).save()
      }
      promise.then(() => {
        this.getCustomers()
        this.ContactsDialog.show = false
      }).catch((error) => {
        this.$alert(error.message)
      })
    },
    handleContactsDialogOpen(data) {
      this.ContactsDialog.Form = data || {}
      this.ContactsDialog.show = true
    },
    handleRemoveContacts(contact) {
      this.$confirm('删除联系人将会删除此联系人的权限账户，请慎重操作！', '删除联系人', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        o(`Partner(${contact.Id})`).remove().save().then(() => {
          this.getCustomers()
          this.getPartnerAccounts()
        }).catch((error) => {
          this.$alert(error.message)
        })
      }).catch(() => { })
    },
    // 权限子模块编辑权限方法
    handlePermissionsUpdate(data) {
      console.log('update', data)
      var promise = o('PartnerAccount/Services.Update').post(data).save()
      promise.then(() => {
        if (data.Id) {
          this.$message('编辑成功!')
        } else {
          this.$message('编辑失败!')
        }
        this.getCustomers()
        this.getPartnerAccounts()
        this.PermissionsDialog.show = false
      }).catch(error => {
        this.$alert(error.message)
      })
    },
    // 子账户创建方法
    handlePermissionsCreate(data) {
      console.log('create', data)
      var promise = o('PartnerAccount/Services.Create').post(data).save()
      promise.then(() => {
        this.$message('创建成功!')
        this.getCustomers()
        this.getPartnerAccounts()
        this.PermissionsDialog.show = false
      }).catch(error => {
        this.$alert(error.message)
      })
    },
    handlePermissionsDialogOpen(row) {
      o('PartnerAccount').expand('Partner').filter(`ExternalId eq (${row.ID})`).first().get().then(({data}) => {
        this.ContactName = data.Partner.Name
        this.PermissionMethod = 'update'
        this.PermissionsDialog.Form = data
        this.PermissionsDialog.show = true
      })
    },
    handleCreatePermissionsDialogOpen(row) {
      this.ContactName = row.Name
      this.PermissionMethod = 'create'
      this.PermissionsDialog.Form = {ExternalId: row.ExternalId, Name: row.Name}
      this.PermissionsDialog.show = true
    },
    handleRemovePermissions(row) {
      this.$confirm('即将删除账户及权限，请慎重操作！', '删除工程师', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const form = {
          ExternalId: row.ID,
        }
        o(`PartnerAccount/Services.DeleteByExId`).post(form).save().then(() => {
          this.$message.success('删除成功')
          this.getCustomers()
          this.getPartnerAccounts()
        }).catch((ex) => { this.$message.error(ex) })
      }).catch(() => {})
    },
    getProvinces() {
      o('Province').get().then(({ data }) => {
        this.Provinces = data.map(province => {
          province.children = []
          return province
        })
      })
    },
    getRegion() {
      const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
      o('PartnerRegion').filter(`PartnerId eq ${user.customer.customerId}`)
      .get().then(({data}) => {
        this.Regions = data
      })
    },
    handleItemChange(val) {
      const Province = this.Provinces.find((province) => province.Id === val[0])
      let City
      if (val[1]) {
        City = Province.children.find((city) => city.Id === val[1])
      }
      if (Province.children.length === 0) {
        o('City').filter(`Province/Id eq ${val}`).get().then(({ data }) => {
          this.$set(Province, 'children', data.map(city => {
            city.children = []
            return city
          }))
        })
      } else if (City && City.children.length === 0) {
        o('County').filter(`City/Id eq ${val[1]}`).get().then(({ data }) => {
          this.$set(City, 'children', data)
        })
      }
    },
    getCustomers(currentPage = 1) {
      this.IsLoading = true
      if (isNaN(currentPage)) currentPage = 1 // FIXME
      const Query = o('Partner')
      const filters = []
      filters.push('IsContact eq true')
      // filters.push('ParentId eq null')
      if (this.contactSearch.Name) {
        filters.push(`contains(Name, '${this.contactSearch.Name}')`)
      }
      if (this.contactSearch.Place.length > 0) {
        const ProvinceId = this.contactSearch.Place[0]
        const CityId = this.contactSearch.Place[1]
        const CountyId = this.contactSearch.Place[2]
        filters.push(`(ProvinceId eq ${ProvinceId} and CityId eq ${CityId} and CountyId eq ${CountyId})`)
      }
      if (filters.length > 0) {
        Query.filter(filters.join(' and '))
      }
      Query.orderBy('Id', 'desc')
      Query.expand('Province')
      .expand('City')
      .expand('County')
      .expand('Accounts')
      .inlineCount()
      .top(10)
      .skip((currentPage - 1) * 10)
      .get().then(({data, inlinecount}) => {
        this.IsLoading = false
        this.contactTotal = inlinecount
        this.Customers = data.map(item => {
          if (item.Province && item.City && item.County) {
            item.StreetAddress = item.Province.Name + item.City.Name + item.County.Name + item.Street
          }
          return item
        })
      })
    },
    permissionPageChange(pageIndex) {
      this.permissionPage = pageIndex
      this.getPartnerAccounts()
    },
    getPartnerAccountsCount() {
      const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
      let url = process.env.BASEDATA_URL + `/Customer/${user.customer.customerCode}/Account`
      this.$http.get(url).then((result) => {
        this.permissionTotal = result.data.length
      })
    },
    getPartnerAccounts() {
      this.IsLoading = true
      const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
      let url = process.env.BASEDATA_URL + `/Customer/Account/Paged?pageIndex=${this.permissionPage}&pageSize=10&input.customer=${user.customer.customerCode}`
      if (this.permissionSearch.Name) {
        url += `&input.name=${this.permissionSearch.Name}`
      }
      console.log('permissionSearch.PartnerRegionId', this.permissionSearch)
      if (this.permissionSearch.PartnerRegionId) {
        url += `&input.regionCode=${this.permissionSearch.PartnerRegionId}`
      }
      this.$http.get(url).then((result) => {
        this.IsLoading = false
        result.data.forEach(item => {
          Object.assign(item, {
            Permission: JSON.parse(item.Permission),
          })
        })
        this.PartnerAccounts = result.data
      }).catch((result) => {
        this.IsLoading = false
        this.$message.error(result)
      })
      // const Query = o('PartnerAccount')
      // const filters = []
      // if (this.permissionSearch.Name) {
      //   filters.push(`contains(Name, '${this.permissionSearch.Name}')`)
      // }
      // if (this.permissionSearch.PartnerRegionId) {
      //   filters.push(`PartnerRegionId eq ${this.permissionSearch.PartnerRegionId}`)
      // }
      // if (filters.length > 0) {
      //   Query.filter(filters.join(' and '))
      // }
      // Query.expand('PartnerRegion,Customer').get().then(({data}) => {
      //   this.PartnerAccounts = data
      //   this.PartnerAccounts.forEach(function(item) {
      //     let array = item.PermissionJson.substring(2, item.PermissionJson.length - 2)
      //     item.PermissionArr = array.split('","')
      //   }, this)
      //   console.log('账户信息', data)
      // })
    },
    /* tab点击事件 */
    currentTabClick(tab, event) {
      switch (tab.label) {
        case '公司基础信息':
          break
        case '联系人':
          this.getCustomers()
          break
        case '账户及权限':
          this.getPartnerAccountsCount()
          this.getPartnerAccounts()
          this.getRegion()
          break
      }
    },
  },
  mounted() {
    this.getProvinces()
    this.getCustomers()
    this.getPartnerAccountsCount()
    this.getPartnerAccounts()
    this.getRegion()
  },
  components: {
    CompanyTab,
    SprDialog,
    SprAddress,
    ContactsDialog,
    PermissionsDialog,
  },
}
</script>

<style lang="less" scoped>
.form {
  margin-top: 15px;
}
.danger {
  color: #ff4949;
}

.btn-group {
  margin-top: 20px;
  .btn {
    width: 100px;
    height: 34px;
    border-radius: 15px;
    background: #cfd5db;
    color: #5e6977;
    &.active {
      background: #20a0ff;
      color: #fff;
    }
  }
}

.card-list,
.card-panel {
  .card {
    margin-top: 10px;
    padding: 12px;
    border: 1px solid #e1e8ee;
    position: relative;
    h4 {
      margin: 0 0 10px 0;
    }
    .form {
      .form-item {
        margin-bottom: 0;
        span {
          margin-right: 10px;
        }
      }
    }
    .btn-area {
      position: absolute;
      right: 0;
      bottom: 0;
      padding-right: 20px;
      .danger {
        color: #ff4949;
      }
    }
  }
}

.card-panel {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .card {
    width: 250px;
    margin-left: 20px;
    padding-bottom: 40px;
    &:nth-child(3n + 1) {
      margin-left: 0;
    }
  }
}

.title {
  font-size: 18px;
  color: #86939e;
  margin: 0;
  line-height: 36px;
}
</style>

<style lang="less">
.customer-info .el-tabs .el-tabs__header {
  margin-left: -10px;
  margin-right: -10px;
  .el-tabs__active-bar {
    display: none;
  }
}

.el-form-item.form-item.no-padding .el-form-item__label {
  padding-bottom: 0;
}

.permission {
  margin-left: 10px;
  color: #4db3ff;
}
</style>



// WEBPACK FOOTER //
// CustomerInfoModule.vue?34a357f4